export const LOCAL_STORAGE_WEB_CLIENT = 'liveshoppingWebClient';

export const WC_NAME = 'nz-player';
